import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-175f2f99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4" }
const _hoisted_2 = { class: "col-form-label fw-bold mb-2" }
const _hoisted_3 = { class: "rounded-3 bg-search p-4 mb-3" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "row mx-4" }
const _hoisted_6 = { class: "row w-100 mb-4 pb-4 border-bottom px-0" }
const _hoisted_7 = { class: "col-lg-2 col-form-label margin-left pe-0" }
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = ["placeholder", "maxlength"]
const _hoisted_10 = { class: "row w-100 mb-4 pb-4 border-bottom px-0" }
const _hoisted_11 = { class: "col-lg-2 col-form-label margin-left pe-0" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = ["placeholder", "maxlength"]
const _hoisted_14 = { class: "row w-100 mb-4 pb-4 border-bottom px-0" }
const _hoisted_15 = { class: "col-lg-2 col-form-label margin-left pe-0" }
const _hoisted_16 = { class: "col-lg-8 d-lg-flex" }
const _hoisted_17 = { class: "form-check me-4 my-auto" }
const _hoisted_18 = {
  class: "form-check-label",
  for: "allMessage"
}
const _hoisted_19 = { class: "form-check me-4 my-auto" }
const _hoisted_20 = {
  class: "form-check-label",
  for: "sendMessage"
}
const _hoisted_21 = { class: "form-check my-auto" }
const _hoisted_22 = {
  class: "form-check-label",
  for: "sendInfo"
}
const _hoisted_23 = { class: "row w-100 mb-4 pb-4 border-bottom px-0" }
const _hoisted_24 = { class: "col-lg-2 col-form-label margin-left pe-0" }
const _hoisted_25 = { class: "col-lg-6" }
const _hoisted_26 = ["placeholder", "maxlength"]
const _hoisted_27 = { class: "row w-100 mb-4 pb-4 border-bottom px-0" }
const _hoisted_28 = { class: "col-lg-2 col-form-label margin-left pe-0" }
const _hoisted_29 = { class: "col-lg-6" }
const _hoisted_30 = ["placeholder", "maxlength"]
const _hoisted_31 = { class: "row w-100 mb-4 pb-4 border-bottom px-0" }
const _hoisted_32 = { class: "col-lg-2 col-form-label margin-left pe-0" }
const _hoisted_33 = { class: "col-lg-8 d-lg-flex" }
const _hoisted_34 = ["for"]
const _hoisted_35 = ["id", "onUpdate:modelValue", "value"]
const _hoisted_36 = { class: "d-flex justify-content-center mb-5" }
const _hoisted_37 = { class: "d-lg-flex" }
const _hoisted_38 = { class: "mx-lg-4" }
const _hoisted_39 = { class: "d-flex" }
const _hoisted_40 = { class: "text-danger ms-2" }
const _hoisted_41 = { class: "d-flex align-items-center fw-bold" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "d-flex align-items-center" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "cursor-pointer" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-danger" })
], -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { key: 3 }
const _hoisted_53 = {
  key: 0,
  class: "text-center fw-bold"
}
const _hoisted_54 = {
  key: 1,
  class: "text-center fw-bold"
}
const _hoisted_55 = { class: "d-lg-flex mt-3" }
const _hoisted_56 = { class: "mx-lg-4" }
const _hoisted_57 = {
  class: "modal fade",
  id: "modalDetail",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_58 = {
  class: "modal fade",
  id: "modalListUser",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}

import Pagination from '@/components/pagination/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { ref, watchEffect, onMounted, watch } from 'vue'
import ModalDetail from './components/ModalDetail.vue'
import ModalListUser from './components/ModalListUser.vue'
import ModalDelete from './components/ModalDelete.vue'
import Table from '@/components/table/index.vue'
import messageTemplateServices from '@/services/message-template.services'
import { useRoute, useRouter } from 'vue-router'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { MAX_LENGTH_MESSAGE_TITLE_SEARCH, MAX_LENGTH_USER_NAME_SEARCH, MAX_LENGTH_USER_ID_SEARCH } from '@/constants/number.ts'
import { ReplayName, numberWithCommas } from '@/constants/common.ts'
// import dayjs from 'dayjs'
import Loading from '@/components/loading/index.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { omit } from 'lodash'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'
import TotalRecords from '@/components/total-records/index.vue'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const messageCode = ref()
const loadingDelete = ref(false)

const data = ref([])
const dataSearchInput = ref({
  title: '',
  created_name: '',
  target_name: '',
  target_mngt_no: '',
  attached_files: 'all',
  message_type: 2,
})
const dataSearch = ref({
  keyword_title: '',
  keyword_created_name: '',
  keyword_target_name: '',
  keyword_target_mngt_no: '',
  attached_files: 'all',
  message_type: 2,
})
const loading = ref<boolean>(false)

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('OE65bread2'),
    to: '',
    active: false,
  },
  {
    content: translate('OE65bread3'),
    to: '',
    active: true,
  },
]

const listStatus = [
  { title: translate('all'), value: 'all' },
  { title: translate('attached'), value: '2' },
  { title: translate('noAttachment'), value: '3' },
]

const showDeleteButton = (item) => {
  // Not show delete button if booking date <= current time + 5 minutes
  const bookingDate = new Date(item.booking_date)
  const timeAfterFiveMinutes = new Date(new Date().getTime() + 5 * 60000)
  const validTime = bookingDate > timeAfterFiveMinutes
  return !item?.published && validTime
}
const modalDelete = ref()
const modalDeleteSuccess = ref()

const getMessageHistory = async () => {
  loading.value = true
  try {
    const res = await messageTemplateServices.getMessageHistory(route.params.id, {
      ...omit(route.query, 'target_management_no'),
      page: route.query?.page || 1,
      page_of_number: route.query?.page_of_number || 30,
      ...dataSearch.value,
    })
    if (res.data?.success) {
      data.value = res?.data
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    loading.value = false
  }
}
onMounted(() => {
  modalDelete.value = new Modal(document.getElementById('deleteMessage'))
  modalDeleteSuccess.value = new Modal(document.getElementById('deleteGroupSuccess'))
})

onMounted(() => {
  if (route?.query?.target_management_no) {
    dataSearchInput.value.target_mngt_no = route?.query?.target_management_no
    dataSearch.value.keyword_target_mngt_no = route?.query?.target_management_no
  }
  getMessageHistory()
})
watch(
  () => dataSearch.value,
  () => {
    if (route.path.match('/sent_messages_history')) getMessageHistory()
  }
)

watch(
  () => route.query,
  () => {
    if (route.path.match('/sent_messages_history')) getMessageHistory()
  }
)
const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

const currentTemplate = ref<number>()
const setCurrent = (data: any): void => {
  currentTemplate.value = data
}

const SearchKey = () => {
  dataSearch.value = {
    keyword_title: dataSearchInput.value.title,
    keyword_created_name: dataSearchInput.value.created_name,
    keyword_target_name: dataSearchInput.value.target_name,
    keyword_target_mngt_no: dataSearchInput.value.target_mngt_no,
    attached_files: dataSearchInput.value.attached_files,
    message_type: dataSearchInput.value.message_type,
  }
  if (dataSearchInput.value.target_mngt_no) router.push({ path: route.path, query: { ...route.query } })
  else router.push({ path: route.path, query: { ...omit(route.query, 'target_management_no') } })
}

const deleteFailed = ref<boolean>(false)

const CancelSending = async (): Promise<void> => {
  loadingDelete.value = true
  const params = {
    invitation_group: currentTemplate.value?.invitation_group,
  }
  try {
    const response = await messageTemplateServices.cancelSendMessage(route.params?.id, currentTemplate.value?.id, params)
    if (response?.status === 200) {
      deleteFailed.value = false
      const dataMess = await messageTemplateServices.getMessageHistory(route.params.id, {
        ...omit(route.query, 'target_management_no'),
        page: route.query?.page || 1,
        page_of_number: route.query?.page_of_number || 30,
        // 2022/09/22 CW-NamPH7425 Fix for UAT#4481: OE65 (Ph2-R20220930)
        ...dataSearch.value,
      })
      if (dataMess.data?.success) {
        data.value = dataMess?.data
      }
      // 2022/09/22 CW-NamPH7425 Fix for UAT#4481: OE65 (Ph2-R20220930)
    } else {
      messageCode.value = response?.response?.data?.data[0]?.message_code
      deleteFailed.value = true
    }
    modalDelete.value.hide()
    modalDeleteSuccess.value.show()
    loadingDelete.value = false
  } catch (error) {
    console.log(error)
    modalDelete.value.hide()
    modalDeleteSuccess.value.show()
    loadingDelete.value = false
    deleteFailed.value = true
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('messageHistory')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(SearchKey, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(translate)('title')), 1),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: _unref(translate)('placeholder'),
                  maxlength: _unref(MAX_LENGTH_MESSAGE_TITLE_SEARCH),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dataSearchInput.value.title) = $event)),
                  class: "form-control"
                }, null, 8, _hoisted_9), [
                  [
                    _vModelText,
                    dataSearchInput.value.title,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(translate)('OE65sender')), 1),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: _unref(translate)('placeholder'),
                  maxlength: _unref(MAX_LENGTH_USER_NAME_SEARCH),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dataSearchInput.value.created_name) = $event)),
                  class: "form-control"
                }, null, 8, _hoisted_13), [
                  [
                    _vModelText,
                    dataSearchInput.value.created_name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(translate)('OE65messageType')), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: "allMessage",
                      value: 2,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dataSearchInput.value.message_type) = $event))
                    }, null, 512), [
                      [_vModelRadio, dataSearchInput.value.message_type]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('all')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: "sendMessage",
                      value: 0,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dataSearchInput.value.message_type) = $event))
                    }, null, 512), [
                      [_vModelRadio, dataSearchInput.value.message_type]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('OE50sendAllMessages')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: "sendInfo",
                      value: 1,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dataSearchInput.value.message_type) = $event))
                    }, null, 512), [
                      [_vModelRadio, dataSearchInput.value.message_type]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('sendInviteOnlyGroupInfo')), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(translate)('OE65sender2')), 1),
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: _unref(translate)('placeholder'),
                  maxlength: _unref(MAX_LENGTH_USER_NAME_SEARCH),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dataSearchInput.value.target_name) = $event)),
                  class: "form-control"
                }, null, 8, _hoisted_26), [
                  [
                    _vModelText,
                    dataSearchInput.value.target_name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(translate)('OE65managementNo2')), 1),
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: _unref(translate)('placeholder'),
                  maxlength: _unref(MAX_LENGTH_USER_ID_SEARCH),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dataSearchInput.value.target_mngt_no) = $event)),
                  class: "form-control"
                }, null, 8, _hoisted_30), [
                  [
                    _vModelText,
                    dataSearchInput.value.target_mngt_no,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(translate)('attachingFile')), 1),
              _createElementVNode("div", _hoisted_33, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(listStatus, (attached_files, index) => {
                  return _createElementVNode("div", {
                    class: "form-check me-4 my-auto",
                    key: index
                  }, [
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: attached_files.value
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "attached_files",
                        id: attached_files.value,
                        "onUpdate:modelValue": ($event: any) => ((dataSearchInput.value.attached_files) = $event),
                        value: attached_files.value
                      }, null, 8, _hoisted_35), [
                        [_vModelRadio, dataSearchInput.value.attached_files]
                      ]),
                      _createTextVNode(" " + _toDisplayString(attached_files.title), 1)
                    ], 8, _hoisted_34)
                  ])
                }), 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(Button, {
              title: _unref(translate)('searchButton'),
              type: 'secondary',
              htmlType: 'submit'
            }, null, 8, ["title"])
          ])
        ], 40, _hoisted_4)
      ]),
      _createVNode(TotalRecords, {
        totalRecords: data.value?.total_records
      }, null, 8, ["totalRecords"]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(Pagination, {
          totalDataOfPage: data.value?.data?.length,
          totalPage: data.value?.total_pages
        }, null, 8, ["totalDataOfPage", "totalPage"]),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number'
          }, null, 8, ["options"])
        ])
      ]),
      _createVNode(Table, {
        columns: [
        //{ field: 'id', name: 'ID', sort: sortField === 'id' },
        { field: 'booking_date', name: _unref(translate)('OE50titleDate'), sort: _ctx.sortField === 'booking_date', defaultSort: 'desc' },
        { field: 'management_no', name: _unref(translate)('managementNo'), sort: _ctx.sortField === 'management_no' },
        { field: 'created_user_name', name: _unref(translate)('OE65sender'), sort: _ctx.sortField === 'created_user_name' },
        { field: 'message_sort_type', name: _unref(translate)('OE65messageType'), sort: _ctx.sortField === 'message_sort_type' },
        { field: 'send_mail', name: _unref(translate)('OE65sendMail'), sort: _ctx.sortField === 'send_mail' },
        { field: 'title', name: _unref(translate)('OE65title') },
        { field: 'content', name: _unref(translate)('OE65content') },
        // { field: 'detail', name: translate('OE65detail') },
        { field: 'has_attached_files', name: _unref(translate)('OE65attached') },
        { field: 'delete', name: _unref(translate)('deleteHistoryMess') },
      ],
        sortCells: ['booking_date', 'management_no', 'created_user_name', 'message_sort_type', 'send_mail']
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value?.data, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: _normalizeClass(["align-middle text-center", { rowEven: index % 2 === 0 }]),
              key: index
            }, [
              _createElementVNode("td", _hoisted_39, [
                _createTextVNode(_toDisplayString(_unref(ConvertFromLocalTime)(item?.booking_date)) + " ", 1),
                _createElementVNode("span", _hoisted_40, _toDisplayString(!item?.published ? _unref(translate)('OE65text1') : ''), 1)
              ]),
              _createElementVNode("td", null, _toDisplayString(item.created_employee_user?.management_no), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(UserAliasIcon, {
                    userType: item?.created_employee_user?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("span", null, _toDisplayString(_unref(ReplayName)(
                  item?.created_employee_user?.is_deleted_in_30_days,
                  item?.created_employee_user?.available,
                  item?.created_employee_user?.family_name,
                  item?.created_employee_user?.given_name,
                  item?.created_employee_user?.user_type
                )) + _toDisplayString(item?.created_employee_user?.user_type == 2 && [0, 1].includes(item?.created_employee_user?.is_deleted_in_30_days)
                  ? `（ ${item?.created_employee_user?.display_name} ）`
                  : ''), 1)
                ])
              ]),
              (item.invitation_group)
                ? (_openBlock(), _createElementBlock("td", _hoisted_42, _toDisplayString(_unref(translate)('sendInviteOnlyGroupInfo')), 1))
                : (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(_unref(translate)('OE50sendAllMessages')), 1)),
              _createElementVNode("td", null, _toDisplayString(!item?.send_mail ? _unref(translate)('OE50personal') : _unref(translate)('OE50personalEmail')), 1),
              _createElementVNode("td", _hoisted_44, [
                (item?.invitation_group)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                      (item?.community_message_targets.alumni > 0)
                        ? (_openBlock(), _createBlock(UserAliasIcon, {
                            key: 0,
                            userType: "alumni"
                          }))
                        : _createCommentVNode("", true),
                      (item?.community_message_targets.employee > 0)
                        ? (_openBlock(), _createBlock(UserAliasIcon, {
                            key: 1,
                            userType: "employee"
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock(UserAliasIcon, {
                      key: 1,
                      userType: item?.user_type
                    }, null, 8, ["userType"])),
                _createElementVNode("u", {
                  class: "cursor-pointer",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#modalListUser",
                  onClick: ($event: any) => (setCurrent(item))
                }, _toDisplayString(_unref(numberWithCommas)(item?.community_message_targets?.alumni + item?.community_message_targets?.employee)) + _toDisplayString(_unref(translate)('OE65user')), 9, _hoisted_46)
              ]),
              _createElementVNode("td", {
                "data-bs-toggle": "modal",
                "data-bs-target": "#modalDetail",
                onClick: ($event: any) => (setCurrent(item))
              }, [
                _createElementVNode("u", _hoisted_48, _toDisplayString(item.title), 1)
              ], 8, _hoisted_47),
              _createElementVNode("td", null, [
                _createElementVNode("i", {
                  class: _normalizeClass({ 'fas fa-paperclip': item.has_attached_files })
                }, null, 2)
              ]),
              (showDeleteButton(item))
                ? (_openBlock(), _createElementBlock("td", {
                    key: 2,
                    onClick: ($event: any) => (setCurrent(item)),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#deleteMessage",
                    class: "cursor-pointer"
                  }, _hoisted_51, 8, _hoisted_49))
                : (_openBlock(), _createElementBlock("td", _hoisted_52))
            ], 2))
          }), 128))
        ]),
        _: 1
      }, 8, ["columns"]),
      (
        !dataSearch.value.keyword_title &&
        !dataSearch.value.keyword_created_name &&
        !dataSearch.value.message_type &&
        !dataSearch.value.keyword_target_name &&
        !dataSearch.value.keyword_target_mngt_no &&
        !dataSearch.value.keyword_attaching_file &&
        data.value.data?.length === 0
      )
        ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString(_unref(translate)('OE65noData')), 1))
        : _createCommentVNode("", true),
      (
        (dataSearch.value.keyword_title ||
          dataSearch.value.keyword_created_name ||
          dataSearch.value.message_type ||
          dataSearch.value.keyword_target_name ||
          dataSearch.value.keyword_target_mngt_no ||
          dataSearch.value.keyword_attaching_file) &&
        data.value.data?.length === 0
      )
        ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(_unref(translate)('OE65searchNo')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_55, [
        _createVNode(Pagination, {
          totalDataOfPage: data.value?.data?.length,
          totalPage: data.value?.total_pages
        }, null, 8, ["totalDataOfPage", "totalPage"]),
        _createElementVNode("div", _hoisted_56, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number'
          }, null, 8, ["options"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createVNode(ModalDetail, { data: currentTemplate.value }, null, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_58, [
      _createVNode(ModalListUser, {
        messageId: currentTemplate.value?.id,
        invitationGroup: currentTemplate.value?.invitation_group
      }, null, 8, ["messageId", "invitationGroup"])
    ]),
    _createVNode(ModalDelete, {
      data: currentTemplate.value,
      CancelSending: CancelSending,
      deleteFailed: deleteFailed.value,
      messageCode: messageCode.value,
      loadingDelete: loadingDelete.value
    }, null, 8, ["data", "deleteFailed", "messageCode", "loadingDelete"]),
    _createVNode(Loading, { loading: loading.value }, null, 8, ["loading"])
  ], 64))
}
}

})